module.exports = __webpack_public_path__ + "static/media/japan.072d33e5.svg";